export default {
    mobileConversionConfig: {
        category: 'boxContainer',
        minHeight: 50,
        isSuitableForProportionGrouping: true,
        filterChildrenWhenHidden: true
    }
}
